import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { AccountsApi, RequestStrategyEnum, type GetAccountsResponse } from '@shared/api';

interface UseAccountsStore {
  data: GetAccountsResponse[];
  loading: boolean;
  error: string | null;
  getAccounts: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAccountsStore = create<UseAccountsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getAccounts: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountsApi.getAccounts(signal);
      set({ data: result || [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: [], loading: false, error: null }),
}));
